<template>
  <div 
    v-if="!loading"
    class="glaxi-menu__header--desktop">
      <ul>
        <li 
            :class="{'glaxi-menu__header--desktop--hasChildren--open': open}"
            class="glaxi-menu__header--desktop--hasChildren">
          <span @click="toggleCategories()">{{ $t('menu.products') }}</span>
        </li>
        <li>
          <router-link :to="{ name: `${lang}.single-page`, params: { slug: $_getPageSlug('Services') } }">
            {{ $t('menu.services') }}
          </router-link>
        </li>
        <li>
          <router-link :to="{ name: `${lang}.single-page`, params: { slug: $_getPageSlug('Academy') } }">
              {{ $t('menu.academy') }}
          </router-link>
        </li>
      </ul>
      <div class="glaxi-menu__header--desktop__logo">
        <router-link :to="{ name: `${lang}.home` }">
          <img 
            :src="logo"
            alt="footer logo Glaxi"
            width="199"
            height="62">
        </router-link>
      </div>
      <ul>
        <li>
          <router-link :to="{ name: `${lang}.single-page`, params: { slug: $_getPageSlug('Quality') } }">
              {{ $t('menu.quality') }}
          </router-link>
        </li>
        <li>
          <router-link :to="{ name: `${lang}.single-page`, params: { slug: $_getPageSlug('Company') } }">
              {{ $t('menu.company') }}
          </router-link>
        </li>
        <li>
          <router-link :to="{ name: `${lang}.single-page`, params: { slug: $_getPageSlug('Contacts') } }">
              {{ $t('menu.contacts') }}
          </router-link>
        </li>
        <languageSwitcher />
        <li @click="searchClick">
          <svg 
            v-if="!openSearch"
            width="18px" height="19px" viewBox="0 0 18 19" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
              <g id="Symbols" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                  <g id="nav-principale" transform="translate(-1352.000000, -16.000000)" fill="#000000" fill-rule="nonzero">
                      <g id="noun_Zoom_340983" transform="translate(1351.000000, 16.000000)">
                          <g id="Group">
                              <g transform="translate(0.000000, 0.021720)" id="Shape">
                                  <g transform="translate(0.620504, 0.241548)">
                                      <g transform="translate(0.192544, -0.000001)">
                                          <path d="M8.22203947,0.397039474 C3.98950658,0.397039474 0.546600877,3.84002193 0.546600877,8.07247807 C0.546600877,12.3050439 3.98950658,15.7479167 8.22203947,15.7479167 C10.1412634,15.7479167 11.8926404,15.0338958 13.2397719,13.8654638 L17.1503048,17.7759967 C17.2878141,17.9192201 17.492008,17.9769141 17.6841359,17.9268281 C17.8762638,17.876742 18.0263034,17.7267024 18.0763895,17.5345745 C18.1264756,17.3424466 18.0687815,17.1382527 17.9255581,17.0007434 L14.0150252,13.0902105 C15.1834616,11.7430811 15.8974781,9.99171689 15.8974781,8.07247807 C15.8974781,3.84002193 12.4545724,0.397039474 8.22203947,0.397039474 Z M8.22203947,1.4935307 C11.8619846,1.4935307 14.8009868,4.43256579 14.8009868,8.07247807 C14.8009868,11.7125 11.8619846,14.6514254 8.22203947,14.6514254 C4.5820943,14.6514254 1.64309211,11.7125 1.64309211,8.07247807 C1.64309211,4.43256579 4.5820943,1.4935307 8.22203947,1.4935307 Z"></path>
                                      </g>
                                  </g>
                              </g>
                          </g>
                      </g>
                  </g>
              </g>
          </svg>
          <svg 
            v-if="openSearch"
            style="width: 18px; height: 18px;"
            width="22px" height="22px" viewBox="0 0 22 22" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
              <g id="Home" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="square">
                  <g id="Desktop-HD---Home---Cerca-nel-Sito" transform="translate(-1386.000000, -33.000000)" stroke="#000000" stroke-width="2">
                      <g id="Group-6" transform="translate(1387.000000, 34.000000)">
                          <path d="M10,-2.51207729 L10,22.5120773" id="Line-4" transform="translate(10.000000, 10.000000) rotate(-45.000000) translate(-10.000000, -10.000000) "></path>
                          <path d="M10,-2.51207729 L10,22.5120773" id="Line-4" transform="translate(10.000000, 10.000000) rotate(-135.000000) translate(-10.000000, -10.000000) "></path>
                      </g>
                  </g>
              </g>
          </svg>
        </li>
      </ul>
    </div>
</template>

<script>

import { mapGetters } from 'vuex'
import LanguageSwitcher from '@/components/GlaxiMenu/LanguageSwitcher/LanguageSwitcher.vue'

import getSinglePages from '@/mixins/getSinglePages.js'

export default {
  name: 'MenuDesktop',
  mixins: [getSinglePages],
  components: {
    LanguageSwitcher
  },
  data: () => ({
    logo: require('@/assets/footer/logo-glaxi.svg')
  }),
  props: {
    open: {
      type: Boolean,
      required: true
    },
    openSearch: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    ...mapGetters([
      'lang'
    ])
  },
  methods: {
    toggleCategories () {
      this.$emit('toggle-categories')
      // this.open = !this.open
      // this.openSearch = false
    },
    searchClick () {
      this.$emit('toggle-search')
      // this.openSearch = !this.openSearch
      // this.open = false
    }
  }
}
</script>

<style lang="scss">
  @import "./desktop.scss";
</style>
